import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/modelsConstants';

const initialState = {
  models: [],
  model: null,
  loading: true,
  brand: null,
  brandLoading: true,
  pageable: {
    totalPages: 1,
    last: true,
    first: true,
    size: 0,
    number: 0,
    totalElements: 0,
  },
  search: {
    search: '',
    page: 0,
    size: 10,
  },
};

const modelsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_MODELS:
      return {
        ...initialState,
      };
    case types.CLEAR_SELECTED_MODEL:
      return {
        ...state,
        model: null,
      };
    case types.GET_MODELS_SUCCESS:
      return {
        ...state,
        loading: false,
        models: payload.data,
        pageable: payload.pageable,
      };
    case types.GET_MODELS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_MODELS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_MODELS_BRAND_SUCCESS:
      return {
        ...state,
        brandLoading: false,
        brand: payload,
      };
    case types.GET_MODELS_BRAND_FAILURE:
      return {
        ...state,
        brandLoading: false,
      };
    case types.GET_MODELS_BRAND_REQUEST:
      return {
        ...state,
        brandLoading: true,
      };
    case types.CLEAR_MODELS_BRAND:
      return {
        ...state,
        brand: null,
        brandLoading: true,
      };
    case types.SELECT_MODEL:
      return {
        ...state,
        model: payload,
      };
    case types.SET_MODELS_PAGE_SIZE:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          size: payload,
        },
      };
    case types.SET_MODELS_SEARCH:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          search: payload,
        },
      };
    case types.NEXT_MODELS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page + 1,
        },
      };
    case types.PREV_MODELS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page - 1,
        },
      };
    default:
      return state;
  }
};

export default modelsReducer;
